import { graphql } from '../graphql';

// Query for organization subscription info (included in organization query)
export const organizationWithSubscriptionQuery = graphql(`
  query OrganizationWithSubscription($id: ID!) {
    organization(id: $id) {
      id
      name
      storageUsedBytes
      storageLimitBytes
      subscription {
        productLine
        plan
        isCustom
        maxSeats
        seatsUsed
        billingStatus
        collectionMethod
        billingInterval
        storageLimitBytes
        currentPeriodEnd
        cancelAtPeriodEnd
        cancelAt
        scheduledPlan
        scheduledChangeAt
        trialEndsAt
      }
    }
  }
`);

// Query for detailed subscription information including invoices
export const subscriptionDetailsQuery = graphql(`
  query SubscriptionDetails($organizationId: ID!) {
    subscriptionDetails(organizationId: $organizationId) {
      info {
        productLine
        plan
        isCustom
        maxSeats
        seatsUsed
        billingStatus
        collectionMethod
        billingInterval
        storageLimitBytes
        currentPeriodEnd
        cancelAtPeriodEnd
        cancelAt
        scheduledPlan
        scheduledChangeAt
        trialEndsAt
      }
      invoices {
        id
        number
        status
        amountDue
        amountPaid
        currency
        created
        dueDate
        hostedInvoiceUrl
        pdfUrl
        taxInvoiceUrl
        taxInvoiceNumber
      }
      nextInvoicePreview {
        amountDue
        currency
        periodStart
        periodEnd
        lines {
          description
          amount
          quantity
        }
      }
      discount {
        promoCodeId
        couponId
        name
        percentOff
        amountOff
        expiresAt
      }
    }
  }
`);

// Hosted Stripe page for the org's open invoice (unfinished checkout / failed renewal)
export const subscriptionPaymentUrlQuery = graphql(`
  query SubscriptionPaymentUrl($organizationId: ID!) {
    subscriptionPaymentUrl(organizationId: $organizationId)
  }
`);

// Query for validating promo codes
export const validatePromoCodeQuery = graphql(`
  query ValidatePromoCode($code: String!) {
    validatePromoCode(code: $code) {
      valid
      name
      percentOff
      amountOff
    }
  }
`);

// Query for subscription pricing
export const subscriptionPricingQuery = graphql(`
  query SubscriptionPricing {
    subscriptionPricing {
      currency
      plans {
        plan
        monthlyAmount
        annualAmount
      }
    }
  }
`);
